import React, { useEffect, useState } from 'react';
import Loading from '../_components/Loading';
import { NoData } from '../_components/NoData';
import { seriesTestService } from '../_services/series.service';
import { SeriesItem } from './SeriesItem';

export const SeriesList = () => {
  //   const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [seriesData, setSeriesData] = useState([]);

  useEffect(() => {
    getSeriesList();
  }, []);
  const getSeriesList = () => {
    setIsLoading(true);
    setSeriesData([]);
    seriesTestService.seriesTestList({ isactive: 1 }).then(
      (res) => {
        setIsLoading(false);

        if (res?.data?.length) {
          setSeriesData(res.data);
        } else {
          setSeriesData([]);
        }
      },
      (err) => {
        console.log(err, 'this is errordata');
        setIsLoading(false);
      },
    );
  };

  return (
    <div className={`${!seriesData.length ? 'd-none' : 'mt-5'}`}>
      <div className='d-flex align-items-center mb-3  headcontainer'>
        <div className='home_head '>Popular Test </div>
      </div>
      {!isLoading && (
        <div className='d-flex align-items-center gap-1 justify-content-between'>
          <div className=''>
            <div className='d-flex flex-wrap gap-4 courselist'>
              {seriesData?.map((test, index) => {
                return <SeriesItem seriesData={test} key={index} />;
              })}
            </div>
          </div>
        </div>
      )}
      {isLoading && !seriesData?.length && <Loading />}
      {!isLoading && !seriesData?.length && <NoData text='No Series Found' />}
    </div>
  );
};
